import React, { Component } from 'react';


import { FaBars, FaMinusCircle } from 'react-icons/fa';

import { TagInput, TagInputType } from '../../../../../../Components/TagInput/TagInput';
import { Dropdown, Checkbox } from '@swivl-mono/ui';
import { Draggable } from '@hello-pangea/dnd';
import { CheckedState } from '@radix-ui/react-checkbox';

export default class InspectorCondition extends React.Component<any>{
  constructor(props) {
    super(props)
    this.deletePressed = this.deletePressed.bind(this)
    this.handleCheckAnyLocationChange = this.handleCheckAnyLocationChange.bind(this)
    //this.moveItemInArray = this.moveItemInArray.bind(this)
  }
  deletePressed() { this.props.deleteValue(this.props.arrayName, this.props.arrayIndex) }
  
  handleCheckAnyLocationChange(checked: CheckedState) {
    const checkAnyLocationName = this.props.arrayName + "." + this.props.arrayIndex + ".checkAnyLocation";
    this.props.onChange({
      target: {
        name: checkAnyLocationName,
        value: checked === true
      }
    });
  }
  // moveItemInArray(arrayName, itemIndex, up) { // NEed a special move item in array method so we dont move past ELSE
  //   if (itemIndex != this.props.conditions.length - 2) {
  //   }
  // }

  render() {

    var operatorName = this.props.arrayName + "." + this.props.arrayIndex + ".operator"; // + this.props.value2;
    const val2Name = this.props.arrayName + "." + this.props.arrayIndex + ".value2" // + this.props.value2;
    
    // Check if the node's value1 is a location variable
    const nodeValue1 = this.props.nodeValue1?.replace("#*", "").replace("*#", "");
    const isLocationVariable = nodeValue1?.startsWith("Location:");
    
    // Show checkbox only for location variables and when operator is not 'else'
    const showCheckAnyLocation = isLocationVariable && this.props.condition.operator !== 'else';

    let val2Dropdown = (this.props.condition.operator != "isSet") ? <TagInput
      value={this.props.condition.value2}
      onChange={this.props.onChange}
      name={this.props.val2Name}
      type={TagInputType.SingleLine}
    /> : null;

    // <UserVariablesDropdown value={this.props.condition.value2} onChange={this.props.onChange} name={this.props.val2Name} userVariables={this.props.userVariables} entities={this.props.entities} showEntities={true} currentVal={this.props.condition.value2} allowTextInput={true} hideNone={true}/> : null;
    let conditionOptions:any = [];
    conditionOptions.push({ value: 'isSet', label: 'Is Set', name: "Is Set" }, { value: '==', label: 'Equal To', name: "Is Equal To", id: '==' }, { value: '!==', label: "Not Equal To", name: "Is Not Equal To", id: '!==' }, { value: '>', label: 'Greater Than', name: 'Is Greater Than', id: '>' }, { value: '<', label: 'Less Than', name: 'Is Less Than', id: '<' });

    // var selectedOption;
    // for (var i = 0; i < conditionOptions.length; i++) {
    //   if (this.props.currentVal && this.props.currentVal === conditionOptions[i].value ) {
    //     selectedOption = conditionOptions[i].id;
    //   }
    // }

    const content = this.props.condition.operator === 'else' ? null : <div className="conditionContent">
      {showCheckAnyLocation && (
        <div>
          <Checkbox
            onCheckedChange={this.handleCheckAnyLocationChange}
            label="Check if ANY location matches"
            name="checkAnyLocation"
            checked={this.props.condition.checkAnyLocation || false}
          />
        </div>
      )}
      <div className="conditionSelectionContent">
        <Dropdown options={conditionOptions} value={this.props.condition.operator} onChange={this.props.onChange} name={this.props.name} />
        <span className="deleteButtonIcon logicDelete" onClick={this.deletePressed}><FaMinusCircle />  </span>
      </div>
      <div className="conditionUserVarsDropdown">
        {val2Dropdown}
      </div>
    </div>


    if (!content){ return null; }

    return <Draggable draggableId={"draggable_" + this.props.condition.id} index={this.props.arrayIndex}>
      {
        (provided, snapshot) => (<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>

          <div className="inspectorCondition">
            <FaBars className="dragHandle" />

            {content}
          </div>




        </div>
        )
      }
    </Draggable>



  }
};
